import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiErrorHandlerProvider} from "../api-error-handler/api-error-handler";

@Injectable()
export class LoyaltyServiceProvider {

  constructor(
    public http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider,
  ) {

  }

  getShopsWithLoyaltyPoints(userId) {
    return new Promise((resolve, reject) => {
      this.http.get(`/loyalty-points/${userId}`).subscribe((teams: any) => {
        resolve(teams);
      }, error => {
        this.apiErrorHandler.handleError(error);
        reject(error)
      })
    })
  }

  getShopLoyaltyPoints(userId, shopId) {
    return new Promise((resolve, reject) => {
      this.http.get(`/loyalty-points/${userId}/teams/${shopId}`).subscribe((loyalty: any) => {
        resolve(loyalty);
      }, error => {
        this.apiErrorHandler.handleError(error);
        reject(error)
      })
    })
  }

  getShopLoyaltyPointsHistory(userId, shopId, pageNumber) {
    let endpoint = `/loyalty-points/${userId}/teams/${shopId}/loyalty-points-history`;

    if (pageNumber !== 1){
      endpoint += '?page=' + pageNumber;
    }

    return new Promise((resolve, reject) => {
      this.http.get(endpoint).subscribe((points: any) => {
        resolve(points);
      }, error => {
        this.apiErrorHandler.handleError(error);
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/loyalty-service/loyalty-service.ts